import { DirectionsCar } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";

import { LiveMapMapDisplayedSummaryStyled } from "./live-map.map-displayed-summary.styled";

export interface ILiveMapMapDisplayedSummaryProps {
  ridesCount: number;
  passengersCount?: number;
  /** Hide "Rides on map:" prefix (compact layouts). */
  hidePrefix?: boolean;
}

export const LiveMapMapDisplayedSummary: FC<
  ILiveMapMapDisplayedSummaryProps
> = ({ ridesCount, passengersCount, hidePrefix = false }) => {
  const { t } = useTranslation();

  return (
    <LiveMapMapDisplayedSummaryStyled>
      {!hidePrefix && (
        <span className="live-map-displayed-prefix">
          {t("rideMap.LIVE_MAP_MAP_DISPLAYED_PREFIX")}
        </span>
      )}
      <span className="live-map-displayed-stat">
        <DirectionsCar
          className="live-map-displayed-stat-icon live-map-displayed-stat-icon--mui"
          aria-hidden
        />
        <span>{ridesCount}</span>
      </span>
      {passengersCount !== undefined && (
        <span className="live-map-displayed-stat">
          <SVG_MUI.PassengersIconSVG
            className="live-map-displayed-stat-icon"
            aria-hidden
          />
          <span>{passengersCount}</span>
        </span>
      )}
    </LiveMapMapDisplayedSummaryStyled>
  );
};
